import renderComponent from '../../../render_component';
import LmsSignUp from './App.vue';

renderComponent('#lms-sign-up', { LmsSignUp });
